import React from 'react';
import { Checkbox, FormControlLabel, Box } from '@mui/material';
import FilterGridRow from './FilterGridRow';
import { VisitType } from "~/providers/OrgConfigProvider";

interface SelectServicesProps {
  serviceOptions:VisitType["visitTypeServices"];
  selectedServicesIds: Set<number>;
  setSelectedServicesIds: (ids: Set<number>) => void;
}

const SelectServices: React.FC<SelectServicesProps> = ({ serviceOptions, selectedServicesIds, setSelectedServicesIds }) => {
  const renderServiceOptions = () => {
    return serviceOptions?.map((serviceOption) => {
      if (!serviceOption?.service?.id) return null;

      return (
        <FormControlLabel
          key={`${serviceOption.service.id}`}
          control={
            <Checkbox
              value={serviceOption.service.id}
              checked={selectedServicesIds.has(serviceOption.service.id)}
              onChange={(e) => {
                if (!serviceOption?.service?.id) return;
                const newSelectedServicesIds = new Set(selectedServicesIds);
                if (e.target.checked) {
                  newSelectedServicesIds.add(serviceOption.service.id);
                } else {
                  newSelectedServicesIds.delete(serviceOption.service.id);
                }
                setSelectedServicesIds(newSelectedServicesIds);
              }}
            />
          }
          label={serviceOption.service.name}
        />
      );
    });
  };

  return (
    <Box maxWidth={600}>
      <FilterGridRow label="Services">
        {renderServiceOptions()}
      </FilterGridRow>
    </Box>
  );
};

export default SelectServices;
